<section id="work" name="work">
	<div class="container desc">
		<div class="row">
			<div class="col-lg-2 col-lg-offset-1">
				<h5><i class="fa fa-briefcase"></i> WORK</h5>
			</div>
			<div class="col-lg-8">
				<accordion [isAnimated]="true">
					<accordion-group *ngFor="let work of works">
						<div accordion-heading (click)="work.isOpen = !work.isOpen">
							<span *ngIf="work.yearEnd">{{
								work.company +
									" (" +
									(work.yearStart | date: "MMM-yyyy") +
									"-" +
									(work.yearEnd | date: "MMM-yyyy") +
									")"
							}}</span>
							<span *ngIf="!work.yearEnd">{{
								work.company +
									" (" +
									(work.yearStart | date: "MMM-yyyy") +
									"- Present)"
							}}</span>
							<div
								class="pull-right glyphicon"
								[ngClass]="{
									'glyphicon-chevron-down': work?.isOpen,
									'glyphicon-chevron-right': !work?.isOpen
								}"
							></div>
						</div>
						<p>
							<i class="fa fa-folder-open" aria-hidden="true"></i> PROJECT(S)
						</p>
						<accordion-group *ngFor="let project of work.projects">
							<div accordion-heading (click)="project.isOpen = !project.isOpen">
								{{ project.title }}
								<i
									class="pull-right glyphicon"
									[ngClass]="{
										'glyphicon-chevron-down': project?.isOpen,
										'glyphicon-chevron-right': !project?.isOpen
									}"
								></i>
							</div>
							<div>
								<i>{{ project.description }}</i>
							</div>
							<div>
								<i>{{ project.description1 }}</i>
							</div>
							<div>
								<i>{{ project.description2 }}</i>
							</div>
							<div>
								<i>{{ project.description3 }}</i>
							</div>
							<br />
							<div *ngFor="let role of project.roles">
								<p>
									<i>{{ role.title }}</i
									><br />
								</p>
								<p><i>Responsibilities</i><br /></p>
								<ul>
									<li *ngFor="let responsibility of role.responsibilities">
										{{ responsibility }}
									</li>
								</ul>
							</div>
							<p>
								<i>Technologies</i><br />
								<i>{{ project.technologies }}</i>
							</p>
						</accordion-group>
					</accordion-group>
				</accordion>
			</div>
		</div>
		<br />
		<hr />
	</div>
</section>
